export default __webpack_public_path__ + "static/media/green_dolphin_icon_for.8c6bf02d.svg";